import {connect} from 'react-redux';
import SupporterScreen from '../../components/screens/SupporterScreen';

const mapStateToProps = state => {
    return {
        supporterDetails: state.supporterDetails,
        supporterProject: state.supporterProject,
        supporters: state.supporterList.supporters
    }
};

const SupporterScreenContainer = connect(
    mapStateToProps,
    null
)(SupporterScreen);

export default SupporterScreenContainer;